import React from 'react';
import { Id, Slide, ToastContainer, ToastOptions, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Toast types
export type ToastType = 'success' | 'error' | 'info' | 'warning' | 'loading';

// Default toast options
const defaultOptions: ToastOptions = {
  position: 'top-right',
  autoClose: 4000,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  theme: 'light',
  transition: Slide,
  role: 'alert',
};

// Updated toast function that returns the toast ID
export const showToast = (
  message: string,
  options?: ToastOptions,
  type: ToastType = 'info',
): Id => {
  const toastOptions = { ...defaultOptions, ...options };

  switch (type) {
    case 'success':
      return toast.success(message, toastOptions);
    case 'error':
      return toast.error(message, toastOptions);
    case 'info':
      return toast.info(message, toastOptions);
    case 'warning':
      return toast.warning(message, toastOptions);
    case 'loading':
      return toast.loading(message, { ...toastOptions });
    default:
      return toast(message, toastOptions);
  }
};

// Helper function to dismiss a specific toast
export const dismissToast = (toastId: Id) => {
  toast.dismiss(toastId);
};

// Helper function to dismiss all toasts
export const dismissAllToasts = () => {
  toast.dismiss();
};

// Toast provider component
export const ToastProvider: React.FC = () => (
  <ToastContainer hideProgressBar limit={1} style={{ zIndex: 99999999 }} />
);
